import { Modal, Stack, Text, Group, Button, useMantineColorScheme, Box } from "@mantine/core";

export function DeleteConfirmModal({
    opened,
    onClose,
    onDelete,
    selectedCount,
}: {
    opened: boolean;
    onClose: () => void;
    onDelete: () => void;
    selectedCount: number;
}) {
    const { colorScheme } = useMantineColorScheme();
    
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Delete Items"
            centered
            overlayProps={{ backgroundOpacity: 0.1, blur: 2 }}
        >
            <Stack gap="md">
                <Box
                    p="md"
                    style={{
                        border: '1px solid var(--modal-border)',
                        borderRadius: 'var(--mantine-radius-md)',
                        background: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.01)' : 'rgba(255, 255, 255, 0.5)',
                        backdropFilter: colorScheme === 'light' ? 'blur(10px)' : undefined
                    }}
                >
                    <Text size="sm" c={colorScheme === 'dark' ? 'dimmed' : 'gray.7'}>
                        Are you sure you want to delete {selectedCount} item
                        {selectedCount !== 1 ? "s" : ""}? This action cannot be undone.
                    </Text>
                </Box>
                
                <Group justify="flex-end" pt="md">
                    <Button
                        variant={colorScheme === 'dark' ? 'light' : 'subtle'}
                        onClick={onClose}
                        color="gray"
                    >
                        Cancel
                    </Button>
                    <Button
                        color="red"
                        onClick={onDelete}
                        variant="filled"
                    >
                        Delete
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
}
